module.exports = __webpack_public_path__ + "media/applicants/left-arrow-29-45e1f53b.svg";